
import { Reti } from "../Wallets";

export function ChangeChainRedirect(rete = Reti.ETHEREUM) {
    if(rete == Reti.ETHEREUM) {
        window.location.href = "/switch-network-ethereum?redirect=" + window.location.pathname;
    } else if(rete == Reti.BINANCE) {
        window.location.href = "/switch-network-binance?redirect=" + window.location.pathname + encodeURIComponent(window.location.search);
    }
}